import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type ShoppingListPreparedEntityTableName =
    | 'shopping_lists'
    | 'shopping_list_products'
    | 'inventory_products'
    | 'inventory_changes';

export type PreparedShoppingListData = {
    record: Model;
    table: ShoppingListPreparedEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: ShoppingListPreparedEntityTableName,
    operation: ValidationOperation,
): PreparedShoppingListData => ({
    record,
    table,
    operation,
});

export const mapRecords = (
    records: Model[],
    table: ShoppingListPreparedEntityTableName,
    operation: ValidationOperation,
): PreparedShoppingListData[] =>
    records.map((record) => mapRecord(record, table, operation));

export const addPreparedDataBatch = async (
    preparedData: PreparedShoppingListData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
